// extracted by mini-css-extract-plugin
export default {"information-box":"styles_information-box__Fel0f","information-box-info":"styles_information-box-info__rDyeB"};